/**
 * The `lexicon` data registry id (VE-24948 / U5).
 *
 * WHY A DEFAULT LIVES IN CODE AND NOT ONLY IN CONFIG. The id reached the app
 * through `window.config`, and that turned out to be an unreliable channel for
 * something the feature cannot work without:
 *
 *   - standalone, `window.config` comes from `/config.js`, i.e. the GITIGNORED
 *     `static/config.js`. A machine whose copy predates a new key never gets
 *     it, and `git pull` cannot fix that — so adding the id to every tracked
 *     `config_*.js` still left the feature dead on a second machine, twice.
 *   - under the aiWARE shell, `index.html` does
 *     `window.config = window.aiwareConfig || window.config` — a WHOLESALE
 *     replacement — so the repo's `config_*.js` is not consulted at all and no
 *     repo change reaches a shell deployment.
 *
 * A registry id is a data-registry identifier, not a credential, and every
 * sibling registry in this app (`redactionCodesRegistryId`,
 * `redactionStatusesRegistryId`, `caseRegistryId`) is already committed with the
 * SAME value in all four `config_*.js`. There is therefore no per-environment
 * variation being expressed, and moving the constant one layer inward costs
 * nothing while making the feature work with zero configuration anywhere.
 *
 * CONFIG STILL WINS, AND THAT IS NOT A CONTRADICTION OF THE BULLET ABOVE —
 * the two talk about different objects, which an earlier revision of this
 * comment ran together. What the shell replaces is the repo's `config_*.js`;
 * what it replaces it WITH is `window.aiwareConfig`, the deployment's own
 * config, and that does carry registry ids — `redactionCodesRegistryId` is read
 * from exactly this source and Redaction Codes works in production. So
 * `getSagaContext` preferring `window.config.lexiconRegistryId` is a live
 * escape hatch in every deployment mode, and the thing that does NOT work is
 * expecting a repo file edit to reach a shell deployment.
 *
 * That is the only reason to touch this file: if a deployment needs a different
 * registry, set the key in that environment's config, not here.
 *
 * WHAT THIS DOES NOT DO IS TURN THE FEATURE ON. A default id means the app
 * always has somewhere to look; it says nothing about whether anything is there.
 * The on/off condition is whether that registry RESOLVES to a published schema
 * in this environment, which `probeLexiconAvailability` establishes at start-up
 * and reports as `isNotConfigured` (NFR-U5-12). On that signal the side-nav
 * entry, the apply panel and the upload selector all hide and no error is
 * raised — an environment that has not run the provisioning runbook is a
 * legitimate state, not a fault.
 *
 * An earlier revision of this file claimed that path was "effectively
 * unreachable" once a default existed. That was true of the code as it then
 * stood, and it was the bug: the default made the CONFIG check vacuous, and
 * nothing had replaced it with a check of the registry itself.
 */
export const LEXICON_REGISTRY_ID_DEFAULT =
  'd1633cc4-39f0-402e-a754-657149661aa7';
